"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsSearch_en_us = void 0;
function componentsSearch_en_us() {
    return {
        "components.search.advancedsearch": "Advanced Search",
        "components.search.contains": "contains",
        "components.search.matches": "matches",
        "components.search.matcher.exactmatch": "matches",
        "components.search.matcher.equals": "matches",
        "components.search.matcher.includes": "includes",
        "components.search.matcher.startswith": "starts with",
        "components.search.matcher.endswith": "ends with",
        "components.search.matcher.exists": "field exists",
        "components.search.matcher.greaterthan": "greater than",
        "components.search.matcher.greaterthanequals": "greater than equals",
        "components.search.matcher.lessthan": "less than",
        "components.search.matcher.lessthanequals": "less than equals",
        "components.search.matcher.beforerelativetime": "before relative time",
        "components.search.matcher.afterrelativetime": "after relative time",
        "components.search.matcher.inrelativemonth": "in given month",
        "components.storesearch.mode.simple": "simple",
        "components.storesearch.mode.advanced": "advanced",
        "components.storesearch.comperator.or": "or",
        "components.storesearch.comperator.and": "and",
        "components.storesearch.placeholder": "Search by ${value}"
    };
}
exports.componentsSearch_en_us = componentsSearch_en_us;
